import React from 'react';
import { m } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-56" data-mp="5dadzqdl2fl4">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-57" data-mp="5cqz6ij8c7bb">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-58" data-mp="3mujx3qshmovu">
          La decisión es tuya.
        </h2>

        <div className="mt-8 grid gap-4 text-left sm:grid-cols-2" data-id="element-59" data-mp="3rqs60mg3dluk">
          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-60" data-mp="3dsamz214sxiz">
            <p className="text-xs font-bold uppercase tracking-wide text-muted" data-id="element-61" data-mp="38t7j3kww0xcl">Opción A (la que conoces)</p>
            <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-62" data-mp="124ksnranixxz">
              Puedes seguir viendo cómo tus herramientas cogen polvo, tus retales se van a la basura, y
              esperas a que suene el teléfono para una reforma pesada que no te pagan lo que vale.
            </p>
          </m.div>
          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.08
        }} className="rounded-2xl border border-brown/30 bg-brown/5 p-6" data-id="element-63" data-mp="l8r3gnvrpgjf">
            <p className="text-xs font-bold uppercase tracking-wide text-brown" data-id="element-64" data-mp="7ass7rcqu085">Opción B (la que queremos para ti)</p>
            <p className="mt-2 text-sm leading-relaxed text-ink" data-id="element-65" data-mp="2c94blelaed5">
              Llegar al taller mañana con un plan. Fabricar tu primer soporte de laptop o tabla gourmet en
              40 minutos. Publicarlo antes de cenar. Venderlo al día siguiente.
            </p>
          </m.div>
        </div>

        <p className="mt-8 text-base leading-relaxed text-ink sm:text-lg" data-id="element-66" data-mp="1ro1gtsrruxk3">
          El precio de dos menús del día. <span className="font-semibold text-brown" data-id="element-67" data-mp="1mq9qh36rzji0">El valor de tu nuevo negocio artesanal.</span>
        </p>
      </div>
    </section>;
}